import system from 'system-components'

const Hr = system(
  {
    is: 'hr',
    height: 4,
    bg: 'gray.5',
    display: 'block',
    border: 'none',
    m: 0,
  }
)

Hr.displayName = 'Hr'

export default Hr



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Hr.js